import { AppRefreshModalView } from './AppRefreshModalView';
import { useAppRefreshModal } from './useAppRefreshModal';
import { useAppUpdateListener } from './useAppUpdateListener';

export function AppRefreshModal() {
  const { onUpdateAvailable, ...props } = useAppRefreshModal();

  useAppUpdateListener(onUpdateAvailable);

  return <AppRefreshModalView {...props} />;
}
